import { useUpdateEffect } from 'ahooks';
import en_US from 'antd/lib/locale/en_US';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { i18nCache } from '@/i18n/url';
import { supportLanguages } from '@/utils/constants';

export function supportLang(lang: string) {
  // todo 新增三种语言
  // 荷兰语 nl-NL
  // 意大利语 it-IT
  // 波兰语 pl-PL
  const langArr = ['en', ...supportLanguages];
  return langArr.indexOf(lang) !== -1;
}

export const supportLanguage = [
  'fil-PH',
  'es-MX',
  'es-AR',
  'es-419',
  'ar-SA',
  'zh-MY',
];

export function useApp() {
  const [locale, setLocale] = useState(en_US);
  // eslint-disable-next-line
  const { t, i18n } = useTranslation();
  const loading = useRef(i18n.resolvedLanguage);
  console.log('i18n.resolvedLanguage', i18n.resolvedLanguage);

  const setAntdLocale = async (antL: string) => {
    if (antL === 'en_US' || supportLanguage.includes(antL)) {
      const en_US = await i18nCache.dynamicGetAntDLocaleEnUS();
      setLocale(en_US);
    } else if (antL === 'es_ES') {
      const es_ES = await i18nCache.dynamicGetAntDLocaleEsES();
      setLocale(es_ES);
    } else if (antL === 'fr_FR') {
      const fr_FR = await i18nCache.dynamicGetAntDLocaleFrFR();
      setLocale(fr_FR);
    } else if (antL === 'hi_IN') {
      const hi_IN = await i18nCache.dynamicGetAntDLocaleHiIN();
      setLocale(hi_IN);
    } else if (antL === 'id_ID') {
      const id_ID = await i18nCache.dynamicGetAntDLocaleJaJP();
      setLocale(id_ID);
    } else if (antL === 'ja_JP') {
      const ja_JP = await i18nCache.dynamicGetAntDLocaleJaJP();
      setLocale(ja_JP);
    } else if (antL === 'kk_KZ') {
      const kk_KZ = await i18nCache.dynamicGetAntDLocaleKkKZ();
      setLocale(kk_KZ);
    } else if (antL === 'pt_BR') {
      const pt_BR = await i18nCache.dynamicGetAntDLocalePtBR();
      setLocale(pt_BR);
    } else if (antL === 'ru_RU') {
      const ru_RU = await i18nCache.dynamicGetAntDLocaleRuRU();
      setLocale(ru_RU);
    } else if (antL === 'th_TH') {
      const th_TH = await i18nCache.dynamicGetAntDLocaleThTH();
      setLocale(th_TH);
    } else if (antL === 'tr_TR') {
      const tr_TR = await i18nCache.dynamicGetAntDLocaleTrTR();
      setLocale(tr_TR);
    } else if (antL === 'uk_UA') {
      const uk_UA = await i18nCache.dynamicGetAntDLocaleUkUA();
      setLocale(uk_UA);
    } else if (antL === 'vi_VN') {
      const vi_VN = await i18nCache.dynamicGetAntDLocaleViVN();
      setLocale(vi_VN);
    } else if (antL === 'zh_CN') {
      const zh_CN = await i18nCache.dynamicGetAntDLocaleZhCN();
      setLocale(zh_CN);
    } else if (antL === 'zh_TW') {
      const zh_TW = await i18nCache.dynamicGetAntDLocaleZhTW();
      setLocale(zh_TW);
    } else if (antL === 'nl-NL') {
      const zh_TW = await i18nCache.dynamicGetAntDLocaleNlNL();
      setLocale(zh_TW);
    } else if (antL === 'it-IT') {
      const zh_TW = await i18nCache.dynamicGetAntDLocaleItIT();
      setLocale(zh_TW);
    } else if (antL === 'pl-PL') {
      const zh_TW = await i18nCache.dynamicGetAntDLocalePlPL();
      setLocale(zh_TW);
    }
  };

  useUpdateEffect(() => {
    loading.current = i18n.resolvedLanguage;
  }, [i18n.resolvedLanguage]);

  return {
    loading,
    locale,
    setAntdLocale,
    supportLang,
  };
}
